import { render } from "./PlayoutPagination.vue?vue&type=template&id=b528774e"
import script from "./PlayoutPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutPagination.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayoutV2/PlayoutPagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b528774e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b528774e', __exports__)) {
    api.reload('b528774e', __exports__)
  }
  
  module.hot.accept("./PlayoutPagination.vue?vue&type=template&id=b528774e", () => {
    api.rerender('b528774e', render)
  })

}


export default __exports__